var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0919 15.9082C17.2497 16.0647 17.3384 16.2776 17.3384 16.4998C17.3384 16.722 17.2497 16.935 17.0919 17.0915C16.9355 17.2493 16.7225 17.338 16.5003 17.338C16.2781 17.338 16.0651 17.2493 15.9086 17.0915L9.00027 10.1748L2.09194 17.0915C1.93547 17.2493 1.72247 17.338 1.50027 17.338C1.27808 17.338 1.06508 17.2493 0.908608 17.0915C0.750847 16.935 0.662109 16.722 0.662109 16.4998C0.662109 16.2776 0.750847 16.0647 0.908608 15.9082L7.82527 8.99985L0.908608 2.09151C0.697226 1.88013 0.614672 1.57204 0.692043 1.28328C0.769414 0.99453 0.994956 0.768988 1.28371 0.691616C1.57246 0.614245 1.88056 0.696799 2.09194 0.908181L9.00027 7.82485L15.9086 0.908181C16.2354 0.581413 16.7652 0.581413 17.0919 0.908181C17.4187 1.23495 17.4187 1.76475 17.0919 2.09151L10.1753 8.99985L17.0919 15.9082Z",
    fill: "#062744",
    fillOpacity: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/Cross.e92ed36f9506083eb9c2275577b56127.svg";
export { ForwardRef as ReactComponent };